export default __webpack_public_path__ + "static/media/dongdonge.1ab0daf9.png";